import React, { useState } from "react";
import SectionTitle from "../../../assets/components/TitleGroup";
import { useFixedLayout } from "../../../hooks/useFixedLayout";
import ListCard from "../../../assets/components/ListCard";
import info_red from "../../../assets/icons/warning/info_red.svg";
import { SingleButton } from "../../../assets/components/ButtonGroup";

const AdsRegistSelf5 = ({
    items,
    seed,
    goToStep,
    setStep6Shop,
    targetStep6,
    targetStep7,
}) => {
    const [selectedShop, setSelectedShop] = useState(null);
    const enabled = selectedShop !== null && items.length > 0;
    const { bottomSpace, footerRef } = useFixedLayout();
    const zonecode = seed?.zonecode ?? "";

    const hasOnlyRegisteredStore =
        items.length === 1 && items[0]?.user_id != null;

    return (
        <div className="flex flex-col h-full">
            {/* 이 영역 전체가 AdsRegister의 스크롤 대상 */}
            <div className="flex-1 flex flex-col px-[16px] pt-[16px]">
                <SectionTitle
                    title={
                        hasOnlyRegisteredStore
                            ? "이미 등록된 매장입니다"
                            : "매장 정보 등록"
                    }
                    subTitle={
                        hasOnlyRegisteredStore
                            ? "이미 다른 계정에 등록되어 있어요. 등록된 매장 정보 수정·확인은 고객지원으로 문의해 주세요."
                            : "내 매장 정보를 선택해 주세요."
                    }
                    className="pb-[40px]"
                />

                {/* 매장 리스트 */}
                <div className="space-y-[12px]">
                    {items.length === 0 ? (
                        <div className="text-sm text-gray-500">로딩 중...</div>
                    ) : (
                        items.map((r, idx) => {
                            const hasUser = r.user_id != null;

                            return (
                                <ListCard
                                    key={r.STORE_BUSINESS_NUMBER ?? idx}
                                    title={r.STORE_NAME}
                                    subtitle={[
                                        `(${zonecode})`,
                                        r.ROAD_NAME_ADDRESS,
                                        r.FLOOR_INFO && `${r.FLOOR_INFO}층`,
                                    ]
                                        .filter(Boolean)
                                        .join(" ")}
                                    // user_id 있으면 uncheckable + Chip, 없으면 checkable
                                    mode={hasUser ? "uncheckable" : "checkable"}
                                    chipLabel={hasUser ? "등록된 가게" : undefined}
                                    selected={selectedShop === idx}
                                    onSelect={() =>
                                        setSelectedShop((prev) => (prev === idx ? null : idx))
                                    }
                                />
                            );
                        })
                    )}
                </div>

                {/* "내 매장 정보가 없어요" */}
                <div className="pt-[24px] pb-[32px] text-center">
                    <button
                        onClick={() => goToStep(targetStep7)}
                        className="
                        text-b2 text-text-subtler 
                        underline underline-offset-[2px]
                        decoration-[#59637D]
                        "
                    >
                        내 매장 정보가 없어요
                    </button>
                </div>

                {/* 이 블럭 전체를 '바닥'으로 밀어버림 */}
                <div className="mt-auto">
                    {/* 경고 문구 */}
                    <div className="text-c2 text-text-danger flex gap-[4px] pt-[16px]">
                        <img src={info_red} alt="경고" className="w-[16px] h-[17px]" />
                        <p>
                            본인과 관계 없는 사업장을 등록하는 경우 이용 제한과 법적 제재를 받을 수 있습니다.
                        </p>
                    </div>

                    {/* 버튼 높이만큼 여유 공간 */}
                    <div style={{ height: Math.max(bottomSpace, 0) }} />
                </div>
            </div>

            {/* 하단 다음 버튼 */}
            <div
                ref={footerRef}
                className="fixed bottom-0 left-0 right-0 bg-surface-default"
            >
                <SingleButton
                    onClick={() => {
                        if (!enabled) return;
                        const picked = items[selectedShop];
                        setStep6Shop({ ...picked, zonecode });
                        goToStep(targetStep6);
                    }}
                    disabled={!enabled}
                >
                    다음
                </SingleButton>
            </div>
        </div>
    );
};

export default AdsRegistSelf5;
